import React, { useEffect } from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { DropdownMenu } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/components/DropdownMenu';
import { timeZoneDisplayNames } from './utils';
import RuleStore from '../stores';

export const RuleTimes = React.memo(() => {
  const { times, selectedTimeZone, startTime, endTime, setStartTime, setEndTime, setSelectedTimeZone } = RuleStore(
    (s) => ({
      times: s.times,
      selectedTimeZone: s.selectedTimeZone,
      startTime: s.startTime,
      endTime: s.endTime,
      setStartTime: s.setStartTime,
      setEndTime: s.setEndTime,
      setSelectedTimeZone: s.setSelectedTimeZone
    })
  );
  useEffect(() => {
    if (+startTime.id >= +endTime?.id) {
      setEndTime(undefined);
    }
  }, [startTime, endTime, setEndTime, times]);

  return (
    <Flex flexDirection="column">
      <Text variant="h7">Time</Text>
      <Flex className="ruleRow">
        <DropdownMenu
          options={times.slice(0, times.length - 1)}
          selectedId={startTime.id}
          onChange={(time) => setStartTime(time)}
        />{' '}
        to
        <DropdownMenu
          options={times.filter((i) => +i.id > +startTime.id)}
          selectedId={endTime?.id}
          onChange={(time) => setEndTime(time)}
          slMenuProps={{
            fixSelectedId: false
          }}
          iconStyle={{ marginLeft: '10px' }}
        />
        <DropdownMenu
          options={Object.keys(timeZoneDisplayNames).map((tz) => ({
            id: tz,
            label: timeZoneDisplayNames[tz]
          }))}
          selectedId={selectedTimeZone}
          onChange={(tz) => setSelectedTimeZone(tz.id)}
          slMenuProps={{
            fixSelectedId: false
          }}
        />
      </Flex>
    </Flex>
  );
});

RuleTimes.displayName = 'RuleTimes';
